import * as actionTypes from "../_constants/article.constants";

const initialState = {
  addedItems: []
};

export function article(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ADD_PRODUCT:
      return {
        ...state,
        addedItems: [...state.addedItems, action.payload]
      };
    case actionTypes.REMOVE_PRODUCT:
      return {
        ...state,
        addedItems: state.addedItems.filter(
          item => item.id !== action.payload.id
        )
      };
    case actionTypes.INCREMENT_QUANTITY:
      return {
        ...state,
        addedItems: [
          ...state.addedItems.map(item => {
            if (item.id === action.payload) {
              item.count = item.count + 1;
            }
            return item;
          })
        ]
      };
    case actionTypes.DECREMENT_QUANTITY:
      return {
        ...state,
        addedItems: [
          ...state.addedItems.map(item => {
            if (item.id === action.payload) {
              if (item.count > 1) item.count--;
            }
            return item;
          })
        ]
      };
    case actionTypes.RESET_ALL:
      return {
        ...state,
        addedItems: []
      };
    default:
      return state;
  }
}
